import React from 'react';

import { CardElement } from '@stripe/react-stripe-js';
import type { StripeCardElementChangeEvent } from '@stripe/stripe-js';

import { useIsDarkMode } from '#src/app/shared/hooks/dom';
import { stripeElementDomId } from '#src/app/shared/utils/payments';

type Props = {
	onChange?: (event: StripeCardElementChangeEvent) => unknown;
	disabled?: boolean;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const CardElementWrapper: React.FC<Props> = ({ onChange, disabled, onFocus, onBlur }) => {
	const isDarkMode = useIsDarkMode();

	return (
		<CardElement
			id={stripeElementDomId('card')}
			options={{
				hidePostalCode: true,
				disableLink: true,
				hideIcon: true,
				disabled,
				style: {
					base: {
						fontSize: '16px',
						color: isDarkMode ? '#ffffff' : '#2d2f37',
						'::placeholder': {
							color: isDarkMode ? '#cbcfda' : 'rgba(58, 62, 73, 0.8)',
						},
					},
				},
			}}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	);
};
